import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { ClientService } from '../../../../services/client-service';
import { IHealthwiseDocument, IHealthwiseSession } from '../../../../models/client';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';




@Component( {
  selector: 'app-healthwise-component',
  imports: [
    DatePipe,
    MatButtonModule,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatIcon,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './healthwise-component.html',
  styleUrl: './healthwise-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class HealthwiseComponent implements OnInit, AfterViewInit
{
  @ViewChild( MatPaginator ) paginator!: MatPaginator;

  constructor(
    private _clientService: ClientService,
    private _cdr: ChangeDetectorRef,
  ) { }

  public clientId = input.required<string>();

  public legend = 'Healthwise Documents';

  public dataSource = new MatTableDataSource<IHealthwiseDocument>( [] );
  public documents: IHealthwiseDocument[] | undefined;
  public hwSession: IHealthwiseSession | undefined;
  public searching: boolean = false;

  protected length = 0;
  protected pageIndex = 0;
  protected pageSizeOptions = [12, 24, 50, 100];

  async ngOnInit(): Promise<void>
  {
  }

  async ngAfterViewInit(): Promise<void>
  {
    this.hwSession = await this._clientService.getHealthwiseLaunchUrl( this.clientId() );
    if ( !this.hwSession ) throw new Error( 'Error while starting session in Documentation search app.' );

    await this.getData();
    this._cdr.detectChanges();
  }

  async getData()
  {
    this.dataSource.data = await this._clientService.getHealthwiseDocuments( this.clientId() ) || [];
    this.dataSource.paginator = this.paginator;
    this.documents = this.dataSource._pageData( this.dataSource.data );
  }


  pageChanged( event: PageEvent )
  {
    this.pageIndex = event.pageIndex;
    this.documents = this.dataSource._pageData( this.dataSource.data );
  }

  async openDocument( documentId: number )
  {
    const file = await this._clientService.printHealthwiseDocument( documentId );
    if ( !file ) throw new Error( 'Document not found' );
    const fileUrl = window.URL.createObjectURL( file );
    window.open( fileUrl, `Document_${documentId}` );
  }


  applyFilter( event: Event )
  {
    const filterValue = ( event.target as HTMLInputElement ).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if ( this.dataSource.paginator )
    {
      this.documents = this.dataSource._pageData( this.dataSource.filteredData );
      this.dataSource.paginator.firstPage();     
    }
  }

  async stopSearching()
  {
    this.searching = false;
    await this._clientService.endHealthwiseSession( this.clientId(), this.hwSession?.sessionId! );
    await this.getData();
    this._cdr.detectChanges();
  }

}
